<template>
    <div>
        <modal v-model="importModal" title="Importar procedimentos" @hide="resetImportModal">
            <div class="row">
                <div class="col-lg-5">
                    <div class="form-group">
                        <label class="control-label">Apagar a tabela existente</label><br>
                        <input type="checkbox" id="checkbox" v-model="deleteActualTable">
                        <label for="checkbox">{{ deleteActualTable ? 'Apagarei a tabela atual. ATENÇÃO: Todas as tabelas de preço de planos deverão ser revisadas.' : 'Não apagarei a tabela atual' }}</label>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="form-group">
                        <label class="control-label">Arquivo EXCEL
                            <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <alert type="warning">
                        <p><i class="fa fa-exclamation-triangle fa-2x"></i> Atenção.</p>
                        <p>Ao selecionar a opção (Apagar a tabela existente), a tabela importada substituirá por completo a tabela atual. Caso não selecione esta opção, 
                            procedimentos com mesmo código e nome terão seus valores alterados, novos procedimentos serão incluídos e o restante permanecerá inalterado. <br>
                            Caso a categoria não exista, uma nova categoria será criada.
                        </p>
                        <p>Somente arquivos do tipo excel serão aceitos e devem ter o seguinte formato:</p>
                        <hr>
                        <table border="1" width="100%">
                            <thead>
                                <th>codigo</th>
                                <th>procedimento</th>
                                <th>categoria</th>
                                <th>valor</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>123-xxx</td>
                                    <td>xxxxxx</td>
                                    <td>xxxxxx</td>
                                    <td>9999,99</td>
                                </tr>
                                <tr>
                                    <td>123-xxx</td>
                                    <td>xxxxxx</td>
                                    <td>xxxxxx</td>
                                    <td>9999,99</td>
                                </tr>
                                <tr>
                                    <td>123-xxx</td>
                                    <td>xxxxxx</td>
                                    <td>xxxxxx</td>
                                    <td>9999,99</td>
                                </tr>
                            </tbody>
                        </table>
                    </alert>
                </div>
            </div>

            <div slot="footer">
                <btn @click="importModal=false">Cancelar</btn>
                <btn v-if="disableImportButton" type="primary" disabled ><font-awesome-icon icon="file-import"></font-awesome-icon> Importar</btn>
                <btn v-else type="primary" @click="importProcedures"><font-awesome-icon icon="file-import"></font-awesome-icon> Importar</btn>
            </div>
        </modal>
        <button type="button" @click="importModal = true" class="btn btn-outline-warning"><i class="fa fa-file-excel-o" aria-hidden="true"></i> Importar tratamentos</button>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { faFileImport } from '@fortawesome/free-solid-svg-icons'
    library.add(faFileImport)

    export default {
        name: "TreatmentsTable",

        data(){
            return {
                optionsToast: { timeout: 6000, position: 'topCenter' },
                importModal: false,
                deleteActualTable: false,
                disableImportButton: true,
                file: ''
            }
        },

        methods:{
            
            handleFileUpload(){
                this.file = this.$refs.file.files[0];
                if(this.file){
                    if(this.file.type !== 'text/csv' && 
                        this.file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && 
                        this.file.type !== 'application/vnd.ms-excel'){
                            this.$toast.warning('Somente arquivos do tipo excel são aceitos.', 'Aviso', this.optionsToast);
                            this.disableImportButton = true
                            return false
                    } else {
                        this.disableImportButton = null
                    }
                } else {
                    this.disableImportButton = true
                }
            },

            async importProcedures(){
                let formData = new FormData();
                formData.append('delete_table', this.deleteActualTable);
                formData.append('file', this.file);

                const response = await axios.post( '/treatments/import', formData, {headers: {'Content-Type': 'multipart/form-data'}})
               
                if (response.data.type == 'success') {
                    this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                    this.importModal = false
                } else if (response.data.type == 'warning') {
                    this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                }
            },

            resetImportModal(){
                this.importModal = false,
                this.deleteActualTable = false,
                this.disableImportButton = true,
                this.file = '',
                this.$refs.file.value=null
            },

        },
    }
</script>

<style scoped>
    /* Green */
    .btn-outline-success {
        background-color: white;
        border-color: #4CAF50;
        color: green;
    }

    .btn-outline-success:hover {
        background-color: #4CAF50;
        color: white;
    }

    /* Blue */
    .btn-outline-info {
        background-color: white;
        border-color: #2196F3;
        color: dodgerblue
    }

    .infobtn-outline-:hover {
        background: #2196F3;
        color: white;
    }

    /* Orange */
    .btn-outline-warning {
        background-color: white;
        border-color: #ff9800;
        color: orange;
    }

    .btn-outline-warning:hover {
        background: #ff9800;
        color: white;
    }

    /* Red */
    .btn-outline-danger {
        background-color: white;
        border-color: #f44336;
        color: red
    }

    .btn-outline-danger:hover {
        background: #f44336;
        color: white;
    }

    /* Gray */
    .btn-outline-default {
        background-color: white;
        border-color: #e7e7e7;
        color: black;
    }

    .btn-outline-default:hover {
        background: #e7e7e7;
    }
</style>